import React from 'react';
import Slider from "react-slick";

const VideoData = [
    {
        url: "https://www.youtube.com/embed/IE0THJOlUH0?autoplay=0&rel=0",
    },
    // {
    //     url: "https://www.youtube.com/embed/iEla02uDVjk?autoplay=0",
    // },
    {
        url: "https://www.youtube.com/embed/dhMDMop-aWU?autoplay=0",
    },
    {
        url: "https://www.youtube.com/embed/jJTAZqKtsSo?autoplay=0",
    },
        {
        url: "https://www.youtube.com/embed/9k-1ibLao3k?autoplay=0",
    },
    {
        url: "https://www.youtube.com/embed/6aCYzibxcAM?autoplay=0",
    },
    {
        url: "https://www.youtube.com/embed/uMgXrurQ_ug?autoplay=0",
    },
    {
        url: "https://www.youtube.com/embed/OStpg0vCHTw?autoplay=0",
    },
        {
        url: "https://www.youtube.com/embed/27xvJFjWbWg?autoplay=0",
    },
    {
        url: "https://www.youtube.com/embed/ldt5Y6JqbvE?autoplay=0",
    },
    {
        url: "https://www.youtube.com/embed/VkZ-0HZbUhE?autoplay=0",
    },
    {
        url: "https://www.youtube.com/embed/P2Rlcns7tUM?autoplay=0",
    },
    {
        url: "https://www.youtube.com/embed/MmYsEAAQszU?autoplay=0",
    },


];

const MainTestimonial = ({ teamStyle }) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <Slider className="rn-slick-dot rn-slick-arrow mb--60" {...settings}>
                    {VideoData.map((video, index) => (
                        <div key={index} className={`video-slide ${teamStyle}`}>
                            <div className="video-container">
                                {(video.url.includes("youtube") || video.url.includes("youtu.be")) ? (
                                    <iframe
                                        width="100%"
                                        height="560"
                                        src={video.url}
                                        title={`Video ${index + 1}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        style={{ aspectRatio: '16 / 9' }}
                                    ></iframe>
                                ) : (
                                    <video width="100%" controls height="560" style={{ aspectRatio: '16 / 9' }}>
                                        <source src={video.url} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )}
                            </div>
                            <style jsx>{`
                                .video-container {
                                    width: 100%;
                                    position: relative;
                                    overflow: hidden;
                                    height: 350px;
                                }
                                .video-container iframe,
                                .video-container video {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                }
                                .video-slide {
                                    padding: 10px;
                                }
                            `}</style>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default MainTestimonial;
